module.exports = __webpack_public_path__ + "static/iQ-top-2ef025107c32973ca4e53f6bf792293b.png";